
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { css } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var sizes = {
  xs: "1.875rem",
  sm: "2.5rem",
  md: "3.75rem",
  lg: "5rem",
  xl: "7.5rem"
};
var svgSizes = {
  xs: "1rem",
  sm: "1.25rem",
  md: "1.625rem",
  lg: "2rem",
  xl: "3rem"
};
var avatar = function avatar(_ref, _ref2) {
  var typeScaleSizes = _ref.typeScaleSizes;
  var size = _ref2.size,
    bgColor = _ref2.bgColor;
  var fontSizes = {
    xs: typeScaleSizes.xs,
    sm: typeScaleSizes.sm,
    md: typeScaleSizes.lg,
    lg: typeScaleSizes["3xl"],
    xl: typeScaleSizes["4xl"]
  };
  return /*#__PURE__*/ /*#__PURE__*/css("display:block;margin:0;img{display:block;border-radius:50%;height:", sizes[size], ";width:", sizes[size], ";}span{height:", sizes[size], ";width:", sizes[size], ";font-size:", fontSizes[size], ";display:inline-flex;justify-content:center;align-items:center;background:", bgColor, ";color:white;border-radius:50%;svg{height:", svgSizes[size], ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:avatar;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErQlkiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBUaGVtZSwgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuaW1wb3J0IHsgU2l6ZSB9IGZyb20gXCIuL0F2YXRhclwiO1xuXG5jb25zdCBzaXplcyA9IHtcbiAgeHM6IFwiMS44NzVyZW1cIixcbiAgc206IFwiMi41cmVtXCIsXG4gIG1kOiBcIjMuNzVyZW1cIixcbiAgbGc6IFwiNXJlbVwiLFxuICB4bDogXCI3LjVyZW1cIixcbn07XG5cbmNvbnN0IHN2Z1NpemVzID0ge1xuICB4czogXCIxcmVtXCIsXG4gIHNtOiBcIjEuMjVyZW1cIixcbiAgbWQ6IFwiMS42MjVyZW1cIixcbiAgbGc6IFwiMnJlbVwiLFxuICB4bDogXCIzcmVtXCIsXG59O1xuXG5leHBvcnQgY29uc3QgYXZhdGFyID0gKFxuICB7IHR5cGVTY2FsZVNpemVzIH06IFRoZW1lLFxuICB7IHNpemUsIGJnQ29sb3IgfTogeyBzaXplOiBTaXplOyBiZ0NvbG9yOiBzdHJpbmcgfSxcbik6IFNlcmlhbGl6ZWRTdHlsZXMgPT4ge1xuICBjb25zdCBmb250U2l6ZXMgPSB7XG4gICAgeHM6IHR5cGVTY2FsZVNpemVzLnhzLFxuICAgIHNtOiB0eXBlU2NhbGVTaXplcy5zbSxcbiAgICBtZDogdHlwZVNjYWxlU2l6ZXMubGcsXG4gICAgbGc6IHR5cGVTY2FsZVNpemVzW1wiM3hsXCJdLFxuICAgIHhsOiB0eXBlU2NhbGVTaXplc1tcIjR4bFwiXSxcbiAgfTtcblxuICByZXR1cm4gY3NzYFxuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIG1hcmdpbjogMDtcblxuICAgIGltZyB7XG4gICAgICBkaXNwbGF5OiBibG9jaztcbiAgICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICAgIGhlaWdodDogJHtzaXplc1tzaXplXX07XG4gICAgICB3aWR0aDogJHtzaXplc1tzaXplXX07XG4gICAgfVxuXG4gICAgc3BhbiB7XG4gICAgICBoZWlnaHQ6ICR7c2l6ZXNbc2l6ZV19O1xuICAgICAgd2lkdGg6ICR7c2l6ZXNbc2l6ZV19O1xuICAgICAgZm9udC1zaXplOiAke2ZvbnRTaXplc1tzaXplXX07XG4gICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGJhY2tncm91bmQ6ICR7YmdDb2xvcn07XG4gICAgICBjb2xvcjogd2hpdGU7XG4gICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG5cbiAgICAgIHN2ZyB7XG4gICAgICAgIGhlaWdodDogJHtzdmdTaXplc1tzaXplXX07XG4gICAgICB9XG4gICAgfVxuICBgO1xufTtcbiJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:avatar;");
};

export { avatar };
//# sourceMappingURL=styles.js.map
